/** Internal dependencies */
import { apiCall } from "./apiCall";
import { getCurrentFilters } from "./getCurrentFilters";

export function prepareApiCall(parent) {
  const api = JSON.parse(parent.dataset.rest);
  let apiFilter = "";

  // reset pagination
  api.currentpage = 1;
  const offset = parent.querySelector(".offset-posts");
  if (offset) {
    offset.value = 0;
  }

  apiFilter = getCurrentFilters(parent);
  parent.dataset.rest = JSON.stringify(api);

  apiCall(parent, apiFilter, true);
}
